import React from 'react';
import './Footer.css';
const Footer = () => {

    return (
        <div className='footer'>
            <div className='social_link'>
                <a>Facebook Page</a>
                <a>Instagram</a>
                <a>Twitter</a>
                <a>YouTube</a>
            </div>
                <h2>Portfolio Website</h2>
        </div>
    );
};

export default Footer;